<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-模拟显示-轮播图
    -->
    <div class="drag optional" @click.stop="$parent.$parent.onEditer(index)" :class="{selected: index === selectedIndex}">
      <div class="diy-banner" :class="{selected: index === selectedIndex}" 
      :style="{height: (item.params.type == '1'? ((parseFloat(item.style.height)+10)+'px'):'220px')}">
        <div class="img-list" >
         
          <div v-if="item.params.type == '3'" style="display: flex;width: 100%;">
            <div :key="index" style="margin-left: 20px;" v-for="(categorya, index) in item.data">
                {{categorya.name  }}
            </div>
            <div style="clear: both;"></div>
          </div>

  
         
          <div v-if="item.params.type == '1'" style="display: flex;">
            <img v-img-url="categorya.image" 
              style="width: 115px;margin-left: 2%;border-radius: 8px;"
              :style="{height: item.style.height+ 'px',width: item.style.width+ 'px'}"
            
            :key="index" v-for="(categorya, index) in item.data" v-if="index <= 2">
            <div style="clear: both;"></div>
          </div>
          <div v-if="item.params.type == '2'">
            <img v-img-url="categorya.image" 
              style="float: left;width: 115px;margin-left: 2%;border-radius: 8px;
              width: 47%;height: 100px;margin-top: 2%;"
              
            
            :key="index" v-for="(categorya, index) in item.data" v-if="index <= 3">
            <div style="clear: both;"></div>
        </div>
          
          
        
        
        </div>
        
      </div>
      <div class="btn-edit-del">
        <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['item', 'index', 'selectedIndex'],
    methods: {

    }
  };
</script>

<style scoped>
.diy-banner{ height: 180px; overflow: hidden;}
.diy-banner img{width: 100%; height: 180px; object-fit: fill;}
.img-list {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/Categoryas.vue